import { render } from "./SelectImg.vue?vue&type=template&id=0c5fd07e&scoped=true"
import script from "./SelectImg.vue?vue&type=script&lang=js"
export * from "./SelectImg.vue?vue&type=script&lang=js"

import "./SelectImg.vue?vue&type=style&index=0&id=0c5fd07e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5fd07e"]])

export default __exports__